import clsx from 'clsx';
import { Text } from '@frameio/vapor';
import { HighlightText } from '../../HighlightText';
import styles from './TextFieldMatch.module.css';

type TextFieldMatchProps = {
  highlights?: string[];
  text: string;
  truncate?: boolean;
  variant?: 'block' | 'inline';
};

export const TextFieldMatch = ({
  highlights,
  text,
  truncate = true,
  variant = 'block',
}: TextFieldMatchProps) => {
  const hasHighlights = Boolean(highlights?.length);

  const content = hasHighlights ? (
    <HighlightText
      className={styles.matchedText}
      color="body"
      fontWeight="regular"
      highlights={highlights}
      text={text}
      truncate={truncate}
      variant="secondary"
    />
  ) : (
    <Text
      className={styles.matchedText}
      color="body"
      fontWeight="regular"
      truncate={truncate}
      variant="secondary"
    >
      {text}
    </Text>
  );

  return (
    <div
      className={clsx(
        styles.container,
        hasHighlights && styles.withHighlights,
        variant === 'inline' && styles.inline
      )}
    >
      {content}
    </div>
  );
};
